export const JWT_HEADER_NAME = 'www-authentication';
export const SESSION_STORAGE_KEY = 'token';
export const LOCAL_STORAGE_KEY = 'lt';
export const SESSION_RETURN_PATH_KEY = 'loginreturn';

const decodeJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
};

export const getJwtInfo = () => {
  const token = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!token) return null;
  try {
    return decodeJwt(token);
  } catch {
    // 不正な形式でparse出来なかった場合nullを返す
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
    return null;
  }
};

export const getJwt = () => sessionStorage.getItem(SESSION_STORAGE_KEY);

export const setJwt = (token: string) => sessionStorage.setItem(SESSION_STORAGE_KEY, token);

export const deleteJwt = () => sessionStorage.removeItem(SESSION_STORAGE_KEY);

export const setLocalJwt = () => {
  const token = getJwt();
  localStorage.setItem(LOCAL_STORAGE_KEY, String(token));
};

export const getLocalJwt = () => localStorage.getItem(LOCAL_STORAGE_KEY);

export const deleteLocalJwt = () => localStorage.removeItem(LOCAL_STORAGE_KEY);
